import { FallbackProvider } from "@ethersproject/providers";
import { pipe } from "fp-ts/lib/function";
import * as TaskEither from "fp-ts/TaskEither";
import * as Either from "fp-ts/Either";
import { BlockNumberError, UnsupportedProtocolInstanceError } from "./types";
import { ProtocolInstance, TaskEitherExtractRight } from "@silo/types";
import { blockNumberForGraph } from "./block-number-for-graph";
import { graphProtocolInstance } from "./graph-protocol-instance";

export type GraphPrerequisitesError =
  | UnsupportedProtocolInstanceError
  | BlockNumberError;

export type GraphPrerequisites = TaskEitherExtractRight<
  ReturnType<typeof graphPrerequisites>
>;

/**
 * @deprecated
 * Returns prerequisites for fetching data from the graph -
 * minimum block number, and graph endpoint.
 */
export const graphPrerequisites = (
  provider: FallbackProvider,
  protocolInstance: ProtocolInstance
) => {
  return pipe(
    blockNumberForGraph(provider, protocolInstance),
    TaskEither.chainW((minBlockNumber) => {
      return pipe(
        graphProtocolInstance(protocolInstance),
        Either.map((protocolInstance) => ({
          minBlockNumber,
          protocolInstance,
        })),
        TaskEither.fromEither
      );
    }),
    TaskEither.map(({ minBlockNumber, protocolInstance }) => ({
      minBlockNumber,
      protocolInstance,
    }))
  );
};
